// Item library evaluate codes for /roads-sewers/compound-substation's Compound tab
// dev-mode display — mirrors mainServicesEvaluateCodesMapping.ts's/substationBaseEvaluateCodesMapping.ts's
// description -> code lookup pattern.
//
// The source 'Compound' sheet (docs/R&S-Takeoffsheet.xlsx) has its own "Evaluate Code"
// column, but every single row is blank there — no codes have ever been assigned to
// Compound items in the source spec. This list is intentionally empty for now, but kept
// as a real lookup function (not a stub) so Compound.tsx/CompoundBillSummary.tsx follow
// the same find*EvaluateCode(description) convention every other build-up domain uses —
// any codes added here later just work without touching either component.

export interface CompoundEvaluateCodeItem {
  description: string;
  code: string;
}

export const COMPOUND_EVALUATE_CODES: CompoundEvaluateCodeItem[] = [];

export function findCompoundEvaluateCode(description: string): string | undefined {
  return COMPOUND_EVALUATE_CODES.find((i) => i.description === description)?.code;
}
